import LoadingSkeleton from 'marketing-platform-lib/components/LoadingSkeleton';
export default LoadingSkeleton;